import { COMPANY_TITLE, CITY_TITLE } from '../../helpers/constants';
import i18n from '../../plugins/i18n';
import { changedByObject } from '../../helpers/transformToPresentableData';

export function tableOrderMapper(order) {
  const addressExist = order.address;
  return {
    orderId: order.id,
    date: new Date(order.request_date),
    applicant: order.applicant ? applicantObject(order.applicant) : '',
    customer: customerNameObject(order.end_customer || order.applicant),
    address: addressExist ? installationAddressObject(order) : '',
    devices: order.controllable_devices ? deviceNamesObject(order) : null,
    lastChangedBy: changedByObject(order),
    status: order.status,
  };
}

function customerNameObject(customer) {
  if (!customer) return '';
  if (customer.title === COMPANY_TITLE) return customer.company_name || '';
  if (customer.title === CITY_TITLE) return customer.city_name || '';
  return `${customer.name || ''} ${customer.surname || ''}`.trim();
}

function applicantObject(applicant) {
  if (!applicant) {
    applicant = {};
  }
  return applicant.title === COMPANY_TITLE
    ? `${applicant.company_name}`
    : applicant.title === CITY_TITLE
    ? `${i18n.t('clerk_orders_overview_table.city')} ${applicant.city_name}`
    : `${applicant.title} ${applicant.name} ${applicant.surname}`;
}

function deviceNamesObject(order) {
  const orderedDevices = [
    'wallbox',
    'air_conditioning',
    'heat_pump',
    'battery_storage',
  ];

  const existingDevices = orderedDevices
    .filter((device) => order.controllable_devices?.[device])
    .map((device) => mapDeviceName(device));

  const devicesString = existingDevices.join(', ');

  return devicesString;
}

export function mapDeviceName(device) {
  return i18n.t(`consumption_devices.${device}`);
}

function installationAddressObject(order) {
  const full_address = order.address ?? {};
  return `${full_address.street} ${full_address.street_number}, ${full_address.zip} ${full_address.city}`;
}
